"use client";

import { InventoryCard } from "~/components/inventory-card";
import { type RouterOutputs } from "~/trpc/types";

export function Results({
  inventory,
}: {
  inventory: RouterOutputs["inventory"]["search"]["results"];
}) {
  return (
    <div className="grid grid-cols-2 gap-x-2 gap-y-5 sm:gap-x-4 sm:gap-y-10 md:grid-cols-4 lg:grid-cols-5">
      {inventory.map((inventory) => (
        <InventoryCard inventory={inventory} key={inventory.id} />
      ))}
    </div>
  );
}
